<template>
  <img :src="imageUrl" v-bind="$attrs" v-on="$listeners" />
</template>

<script>
import request from '@/utils/request'

/**
 * 根据传入路径获取完整图片展示路径
 * @param {string} path 图片路径
 * @returns {string} 完整图片路径
 */
export function getFullImageUrl(path) {
  if (!path) return ''

  // 按照要求使用 request.default.getUri()
  // 在标准 ESM 中，import request from '@/utils/request' 获取的是 default 导出
  // 如果环境是 CommonJS 或者特定的打包配置，request 可能是模块对象，其 default 属性才是 axios 实例
  const axiosInstance = request.default || request

  // 获取基础路径，如果 getUri 不可用则降级到 baseURL 或默认值
  const baseUri = (typeof axiosInstance.getUri === 'function')
    ? axiosInstance.getUri()
    : (axiosInstance.defaults && axiosInstance.defaults.baseURL) || '/api'

  // 拼接路径，处理斜杠确保路径正确
  const cleanBase = baseUri.endsWith('/') ? baseUri.slice(0, -1) : baseUri
  const cleanPath = path.startsWith('/') ? path : '/' + path
  return cleanBase + cleanPath
}

export default {
  name: 'ImageShow',
  props: {
    // 图片路径入参
    path: {
      type: String,
      required: true,
      default: ''
    }
  },
  computed: {
    imageUrl() {
      return getFullImageUrl(this.path)
    }
  }
}
</script>

<style scoped>
img {
  max-width: 100%;
  display: inline-block;
  vertical-align: middle;
}
</style>
